import type { ApiClient } from '@travel/api-client';
import { MONTEROSA_API_TIMEOUT } from '@travel/traveler-core/constants';

import type { ProviderListFilters, ProviderListItems } from 'ProviderList-Types';

import type { SearchRequestBody } from '../../pages/ProviderListPage/resolver';

export const fetchProviderListItems = (
  http: ApiClient,
  req: SearchRequestBody,
): Promise<ProviderListItems> =>
  http
    .post('/monterosa-api/v2/provider-summaries', {
      method: 'POST',
      req: { ...req },
      values: { ...req },
      timeout: MONTEROSA_API_TIMEOUT,
    })
    .then((data: ProviderListItems) => {
      return data;
    });

export const fetchProviderListFilters = (
  http: ApiClient,
  req: SearchRequestBody,
): Promise<ProviderListFilters> =>
  http
    .post('/monterosa-api/v2/provider-summaries-faceting', {
      method: 'POST',
      req: { ...req },
      values: { ...req },
      timeout: MONTEROSA_API_TIMEOUT,
    })
    .then((data: ProviderListFilters) => {
      return data;
    });
